
<app-modal-mensagem
  *ngIf="!resultado"
  tipo="confirmacao"
  titulo="Excluir tarefa"
  mensagem="Tem certeza que deseja excluir essa tarefa? Esta ação não pode ser desfeita."
  textoConfirmar="Confirmar"
  [exibirCancelar]="true"
  (confirmar)="deleleTask()"
  (cancelar)="fecharModal()"
></app-modal-mensagem>

<app-modal-mensagem
  *ngIf="resultado"
  [tipo]="resultado.tipo"
  [titulo]="resultado.titulo"
  [mensagem]="resultado.mensagem"
  (confirmar)="onFecharResultado()"
></app-modal-mensagem>
